import { render, staticRenderFns } from "./ConfirmRemoveContact.vue?vue&type=template&id=6c91250a"
import script from "./ConfirmRemoveContact.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports